import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { 
  simpleTestDirective,
  testDirective,
  animationDirective, 
  fadeInDirective, 
  slideInLeftDirective, 
  slideInRightDirective, 
  slideInUpDirective, 
  scaleInDirective, 
  rotateInDirective, 
  bounceInDirective 
} from './directives/animation'
import './styles/animations.css'

console.log('=== MAIN.JS LOADING ===')
console.log('Vue version:', Vue.version)
console.log('simpleTestDirective:', simpleTestDirective)
console.log('testDirective:', testDirective)
console.log('fadeInDirective:', fadeInDirective)

// 确保在Vue实例创建前注册指令
const directives = {
  'simple-test': simpleTestDirective,
  'test': testDirective,
  'animate': animationDirective,
  'fade-in': fadeInDirective,
  'slide-in-left': slideInLeftDirective,
  'slide-in-right': slideInRightDirective,
  'slide-in-up': slideInUpDirective,
  'scale-in': scaleInDirective,
  'rotate-in': rotateInDirective,
  'bounce-in': bounceInDirective
}

// 批量注册指令
Object.keys(directives).forEach(name => {
  Vue.directive(name, directives[name])
  console.log(`${name} directive registered`)
})

console.log('All directives registered')
console.log('Available directives:', Object.keys(Vue.options.directives))

// 验证指令是否正确注册
Object.keys(directives).forEach(name => {
  if (Vue.options.directives[name]) {
    console.log(`✓ ${name} directive verified`)
  } else {
    console.log(`✗ ${name} directive NOT found`)
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')